import { IMAGE_BASE_PATH } from "@/config/config";
import { HTTP_STATUS_CODES } from "@/config/constants";
import {
  clearErrorData,
  getErrorDataSelector,
  removeReduxData,
} from "@/features/error/errorSlice";
import { compareTwoStr } from "@/helpers/utils";
import isEmpty from "lodash/isEmpty";
import Image from "next/image";
import { useRouter } from "next/router";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "../form";
import ModalBox from "../ModalBox";

import styles from "./error.module.scss";

function ErrorModal() {
  const error = useSelector(getErrorDataSelector);
  const dispatch = useDispatch();
  const router = useRouter();

  const handleToggle = () => {
    if (error?.status === HTTP_STATUS_CODES.BAD_REQUEST) {
      const baseURL = window.origin;

      router.push(`${baseURL}/servicing/renewal-health`).then(() => {
        dispatch(removeReduxData());
      });
    }
    if (!isEmpty(error?.url)) {
      router.replace(error.url).then(() => {
        dispatch(clearErrorData());
      });
    } else {
      dispatch(clearErrorData());
    }
  };

  const handleMessage = (message) => {
    const msgBifurcation = { msg: message, code: "" };

    if (!isEmpty(message) && compareTwoStr(typeof message, "string")) {
      const pos = message.indexOf(":");

      msgBifurcation.msg = message.substring(pos + 1).trim();
      msgBifurcation.code = message.substring(0, pos);
    }

    return msgBifurcation;
  };

  return (
    <ModalBox show={error.show} toggle={handleToggle} showHeader={false}>
      <div className="text-center">
        <Image
          alt="error"
          className={styles.image}
          src={`${IMAGE_BASE_PATH}/images/errorMonitor.svg`}
          width={250}
          height={135}
        />
        <p className="subHeading font-26 font-sm-24 my-3 w-75 mx-auto text-break">
          {handleMessage(error.msg).msg}
        </p>
        <div className="col-md-4 col-6 mx-auto">
          <Button bottomFixed={false} className="mb-3" onClick={handleToggle}>
            Close
          </Button>
        </div>
      </div>
      <div className="subHeading text-capitalize font-16 font-sm-11 text-right">
        {handleMessage(error.msg).code}
      </div>
    </ModalBox>
  );
}

export default ErrorModal;
